export function couponIssuanceMessage(result: { account_changed?: boolean; replayed?: boolean; coupons_refreshed?: boolean }): string {
  if (result.account_changed) return "one_time_code_previous_account";
  if (result.replayed === true) return "one_time_code_already_received";
  if (result.coupons_refreshed === false) return "one_time_code_refresh_pending";
  return result.replayed === false ? "one_time_code_issued" : "one_time_code_receipt_confirmed";
}
